const themedBackground = {
  light: "var(--ds-surface, #FFFFFF)",
  dark: "var(--ds-surface, #1B2638)"
};
/**
 * Returns the background color depending on the passed through mode.
 * @param mode
 */

export const getBackground = (mode = 'light') => themedBackground[mode];